import Vue from 'vue'

export default {
  getBrandReviews ({ commit }) {
    return Vue.axios.get(`/history/reviews`)
    .then(({ data }) => commit('ADD_BRAND_REVIEWS', data))
  },
  updateBrandReview ({ commit }, data) {
    return Vue.axios.put(`/history/reviews`, data)
    .then(({ data }) => commit('UPDATE_BRAND_REVIEW', data))
  },
  deleteBrandReview ({ commit }, id) {
    return Vue.axios.delete(`/history/reviews/${id}`)
    .then(() => commit('DELETE_BRAND_REVIEW', id))
  },
  updateBrandReviewsOrder ({ commit }, data) {
    commit('ADD_BRAND_REVIEWS', data)
    return Vue.axios.put(`/history/reviews/order`, data)
  },
  getBrandAchievements ({ commit }) {
    return Vue.axios.get(`/history/achievements`)
    .then(({ data }) => commit('ADD_BRAND_ACHIEVEMENTS', data))
  },
  updateBrandAchievement ({ commit }, data) {
    return Vue.axios.put(`/history/achievements`, data)
    .then(({ data }) => commit('UPDATE_BRAND_ACHIEVEMENT', data))
  },
  updateBrandAchievementsOrder ({ commit }, data) {
    commit('ADD_BRAND_ACHIEVEMENTS', data)
    return Vue.axios.put(`/history/achievements/order`, data)
  },
  deleteBrandAchievement ({ commit }, id) {
    return Vue.axios.delete(`/history/achievements/${id}`)
    .then(() => commit('DELETE_BRAND_ACHIEVEMENT', id))
  },
  getRecommendationLetters ({ commit }) {
    return Vue.axios.get(`/history/recommendations/letters`)
    .then(({ data }) => commit('ADD_RECOMMENDATION_LETTERS', data))
  },
  updateRecommendationLettersOrder ({ commit }, data) {
    commit('ADD_RECOMMENDATION_LETTERS', data)
    return Vue.axios.put(`/history/recommendations/letters/order`, data)
  },
  updateRecommendationLetter ({ commit, dispatch }, data) {
    return Vue.axios.put(`/history/recommendations/letters`, data)
    .then(({ data }) => {
      commit('UPDATE_RECOMMENDATION_LETTER', data)
      return data
    })
  },
  deleteRecommendationLetter ({ commit }, id) {
    return Vue.axios.delete(`/history/recommendations/letters/${id}`)
    .then(() => commit('DELETE_RECOMMENDATION_LETTER', id))
  },
  getBrokerageHouses ({ commit }) {
    return Vue.axios.get(`/history/recommendations/brokerage-houses`)
    .then(({ data }) => commit('ADD_BROKERAGE_HOUSES', data))
  },
  updateBrokerageHouse ({ commit, dispatch }, data) {
    return Vue.axios.put(`/history/recommendations/brokerage-houses`, data)
    .then(({ data }) => {
      commit('UPDATE_BROKERAGE_HOUSE', data)
      return data
    })
  },
  updateBrokerageHousesOrder ({ commit }, data) {
    commit('ADD_BROKERAGE_HOUSES', data)
    return Vue.axios.put(`/history/recommendations/brokerage-houses/order`, data)
  },
  deleteBrokerageHouse ({ commit }, id) {
    return Vue.axios.delete(`/history/recommendations/brokerage-houses/${id}`)
    .then(() => commit('DELETE_BROKERAGE_HOUSE', id))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/history.js